<template>
  <SettlementStepCard
    title="Car Delivery"
    :status="status"
    :status-color="statusColor"
    :is-mobile="isMobile"
    v-bind="$attrs"
  >
    <p :class="{ 'text-body': isMobile }">
      At the pick up of your car please take your driver licence or passport and
      reference number <b>{{ orderId }}</b> with you.
    </p>
  </SettlementStepCard>
</template>

<script>
export default {
  name: 'SettlementDeliveryCard',
  props: {
    status: String,
    statusColor: String,
    orderId: String,
    isMobile: Boolean
  },
  components: {
    SettlementStepCard: () => import('../settlement-step-card')
  }
};
</script>
